// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/cloud-arrow-up.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'cloud-arrow-up',
  version: 'outline',
  paths: [
    {
      d: 'M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z',
    },
  ],
}
